import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="guarantee-title" className="w-full bg-ivory px-4 py-10 sm:px-6" data-id="element-107" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl rounded-3xl border-2 border-sage/40 bg-white p-5 text-center sm:p-7" data-id="element-108" data-mp="223685s65k1rq">
        <span className="inline-flex items-center gap-2 rounded-full bg-sage/15 px-3 py-1 font-head text-[10px] font-bold uppercase tracking-wider text-sage sm:text-xs" data-id="element-109" data-mp="1x3tk543joonk">
          <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-110" data-mp="14fo1qnzyrbqw" />
          Zero Risk
        </span>
        <h2 id="guarantee-title" className="mt-2 font-head text-2xl font-extrabold uppercase text-charcoal sm:text-3xl" data-id="element-111" data-mp="1j4k5w9ywg4m8">
          7-Day Money-Back Guarantee
        </h2>
        <p className="mt-2 font-head text-sm font-semibold text-charcoal sm:text-base" data-id="element-112" data-mp="qo9gsbmhx0h7">
          Open the complete system. Review the modules. Explore the classes, sequences, templates,
          and bonuses.
        </p>
        <p className="mt-2 text-sm leading-snug text-softgray" data-id="element-113" data-mp="p01iaak777bb">
          Try Yoga Teaching Vault™ for seven full days. If you are not completely satisfied, contact
          us within the guarantee period and request a full refund.
        </p>
        <p className="mt-3 font-head text-[11px] font-bold uppercase tracking-widest text-sage" data-id="element-114" data-mp="yq4iovtnfnjo">
          Your Purchase Is Protected
        </p>
      </div>
    </section>;
}